/**
 * Converts camelCase to PascalCase for legacy UI consumers.
 * Uses simple capitalization only — acronym keys must be listed in keyOverrides
 * (e.g. sbcUrl → SBCUrl, ssnLastFour → SSNLastFour) to avoid mis-guessing
 * keys like sbcLinks → SBCLinks.
 */
export function camelToPascalCase(key) {
  if (!key) return ''
  return key.charAt(0).toUpperCase() + key.slice(1)
}

function toPascalKey(key, keyOverrides) {
  if (!key) return key
  return keyOverrides[key] ?? camelToPascalCase(key)
}

/**
 * Recursively converts camelCase keys to PascalCase for legacy UI consumers.
 * Pass keyOverrides for domain-specific acronyms that camelToPascalCase cannot infer.
 */
export function convertKeysToPascalCase(obj, keyOverrides = {}) {
  if (obj === null || obj === undefined) {
    return obj
  }

  if (Array.isArray(obj)) {
    return obj.map((item) => convertKeysToPascalCase(item, keyOverrides))
  }

  if (typeof obj === 'object') {
    if (obj instanceof Date || typeof obj.toISOString === 'function') {
      return obj
    }

    return Object.entries(obj).reduce((acc, [key, value]) => {
      acc[toPascalKey(key, keyOverrides)] = convertKeysToPascalCase(
        value,
        keyOverrides
      )
      return acc
    }, {})
  }

  return obj
}
